var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PreviewMedia"},[_c('iframe',{ref:"iframe",staticClass:"midea_table",staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.mediaUrl,"frameborder":"0","charset":"utf-8","scrolling":"auto"}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ed38a40","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commonView/PreviewMedia.vue
// module id = null
// module chunks = 